import { zodResolver } from '@hookform/resolvers/zod'
import { ReactNode } from 'react'
import {
  FieldValues,
  SubmitHandler,
  useForm,
  UseFormReturn,
} from 'react-hook-form'
import { twMerge } from 'tailwind-merge'
import { ZodType, ZodTypeDef } from 'zod'

type FormProps<TFormValues extends FieldValues, Schema> = {
  children: (methods: UseFormReturn<TFormValues>) => ReactNode
  className?: string
  onSubmit: SubmitHandler<TFormValues>
  schema?: Schema
}
export const Form = <
  TFormValues extends Record<string, unknown> = Record<string, number>,
  Schema extends ZodType<unknown, ZodTypeDef, unknown> = ZodType<
    unknown,
    ZodTypeDef,
    unknown
  >,
>({
  children,
  className,
  onSubmit,
  schema,
}: FormProps<TFormValues, Schema>) => {
  const methods = useForm<TFormValues>({
    resolver: schema && zodResolver(schema),
  })
  return (
    <form
      onSubmit={methods.handleSubmit(onSubmit)}
      className={twMerge('', className)}
    >
      {children(methods)}
    </form>
  )
}
